/**
 * Owner: Masa Bayu
 * File: AuthorAvatar.tsx
 * Date:Time: 2026-10-23 01:55
 * Description: §411–§412 — avatar bulat author dikongsi dua skrin: inisial
 *   ikut nada deterministik. §466 S1 — potret ilustrasi dan lencana "verified"
 *   dibuang: hub belum menghantar gambar atau status verifikasi, jadi tiada
 *   apa-apa yang boleh didakwa di sini.
 */

import type { ReactElement } from 'react';
import './author-bits.css';

export interface AuthorAvatarProps {
  readonly initials: string;
  readonly seed: string;
}

const TONE_COUNT = 6;

function toneOf(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return hash % TONE_COUNT;
}

export function AuthorAvatar({ initials, seed }: AuthorAvatarProps): ReactElement {
  return (
    <span className="qxavt" data-tone={toneOf(seed)} aria-hidden="true">
      <span className="qxavt__ini">{initials}</span>
    </span>
  );
}
